import {message, ModalProps, Skeleton} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import FormRender, {Schema, useForm} from 'form-render';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {getCustomerServiceDetail, saveCustomerService} from '../../../service';
import {UploadSinglePhoto} from '../../../../../../Features/Upload/UploadSinglePhoto';

interface Props extends ModalProps {
    serviceDetailId: string;
    customerId: string;
    onOk: () => void;
}

const Index = ({customerId, onOk, serviceDetailId, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: saveCustomerService,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const defaultData = useQuery({
        queryKey: ['getCustomerServiceDetail', customerId, serviceDetailId],
        queryFn: () => getCustomerServiceDetail({customerId, serviceDetailId}),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const schema: Schema = {
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 6,
        fieldCol: 15,
        properties: {
            name: {
                title: '服务名称',
                type: 'string',
                required: true,
            },
            description: {
                title: '服务介绍',
                type: 'string',
                widget: 'textArea',
            },
        },
    };

    return (
        <ProModal {...props} title="详情" onOk={form.submit}>
            <div className={Style.root}>
                <Skeleton active loading={defaultData?.isFetching}>
                    <FormRender
                        form={form}
                        schema={schema}
                        widgets={{UploadSinglePhoto}}
                        onFinish={formData =>
                            onSave.mutate({
                                ...formData,
                                customerId,
                                serviceDetailId,
                            })
                        }
                        footer={false}
                    />
                </Skeleton>
            </div>
        </ProModal>
    );
};

export default Index;
